import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  InputAdornment,
  InputBase,
  Table,
  TableContainer,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomPagination from "./CustomPagination";
import FilledButton from "./FilledButton";
import TableHeader2 from "./TableHeader2";
import UserManagementTableBody2 from "./UserManagementTableBody2";

const styles = {
  box1Style: {
    display: "flex",
    justifyContent: "space-between",
    p: 2,
    borderBottom: "1px solid #E4E4E4",
    alignItems: "center",
  },
  newCompanyButtonStyle: {
    textTransform: "capitalize",
    borderRadius: "20px",
    backgroundColor: "#00A398",
    mr: 2,
    "&:hover": {
      backgroundColor: "#00A398",
    },
  },
  iconStyle: { fontSize: "17px", marginRight: "3px" },
  searchIconStyle: {
    color: "#9F9F9F",
    ml: "3px",
    mr: "-3px",
    width: "20px",
    height: "20px",
  },
  inputStyle: {
    borderRadius: "20px",
    width: "55%",
    height: "32px",
    border: "1px solid #9F9F9F",
  },
  filterDownloadStyle: {
    color: "white",
    borderRadius: "50%",
    backgroundColor: "#0077B6",
    fontSize: "32px",
    padding: "5px",
    cursor: "pointer",
  },
};

function AlertManagement() {
  const [modalOpen, setModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [userList, setUserList] = useState([]);
  const [search, setSearch] = useState("");
  const [filteredRows, setFilteredRows] = useState([]);

  const [tableData, setTableData] = useState({
    columns: ["Name", "Receive Alerts on"],
    rows: [
      {
        id: 1,
        name: "UserName",
        powerPhone: false,
        powerMsg: true,
      },
      {
        id: 2,
        name: "UserName",
        powerPhone: false,
        powerMsg: true,
      },
      {
        id: 3,
        name: "UserName",
        powerPhone: true,
        powerMsg: true,
      },
      {
        id: 4,
        name: "UserName",
        powerPhone: false,
        powerMsg: true,
      },
      {
        id: 5,
        name: "UserName",
        powerPhone: false,
        powerMsg: true,
      },
      {
        id: 6,
        name: "UserName",
        powerPhone: false,
        powerMsg: true,
      },
      {
        id: 7,
        name: "UserName",
        powerPhone: true,
        powerMsg: true,
      },
      {
        id: 8,
        name: "UserName",
        powerPhone: false,
        powerMsg: true,
      },
    ],
  });

  const totalPages = Math.ceil(filteredRows?.length / itemsPerPage);

  const handleChangePage = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleChangeItemsPerPage = (items) => {
    setItemsPerPage(items);
    setCurrentPage(1);
  };

  let currentData = filteredRows?.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  // Ensuring currentData always has 20 items
  const placeholderRow = {};
  while (currentData?.length < itemsPerPage) {
    currentData.push(placeholderRow);
  }

  //   const fetchUsersList = async () => {
  //     try {
  //       const response = await axios.get(
  //         `${BaseURL}/api/v1/users/${localStorage.getItem(
  //           "userid"
  //         )}/1/get-user-list`
  //       );
  //       setUserList(response.data.data);
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   };

  //   useEffect(() => {
  //     fetchUsersList();
  //   }, []);

  useEffect(() => {
    setUserList(tableData.rows);
  }, []);

  const handleUploadClick = () => {
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  useEffect(() => {
    if (userList) {
      const filteredData = userList?.filter((task) =>
        task?.name?.toLowerCase()?.includes(search?.toLowerCase())
      );
      setFilteredRows(filteredData);
      setCurrentPage(1);
    }
  }, [userList, search]);

  return (
    <>
      <Box sx={styles.box1Style}>
        <Typography sx={{ fontSize: "23px", fontWeight: "500" }}>
          Alert Management
        </Typography>
        <Box
          sx={{
            display: "flex",
            gap: "10px",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          <FilledButton
            color={"#0077B6"}
            btnname={"Update"}
            onClick={handleUploadClick}
            width={"100px"}
          />
        </Box>
        {/* <UserManagementModal open={modalOpen} handleClose={handleModalClose} /> */}
      </Box>
      <Box>
        <TableContainer
          sx={{
            width: "100%",
            maxHeight: "89.5vh",
            overflowX: "auto",
          }}
        >
          <Table sx={{ minWidth: 650 }} aria-label="simple table" stickyHeader>
            <TableHeader2 tableData={tableData} />
            <UserManagementTableBody2
              filledRows={currentData}
              tableData={tableData}
              setTableData={setTableData}
            />
          </Table>
        </TableContainer>
        <CustomPagination
          currentPage={currentPage}
          totalPages={totalPages}
          changePage={handleChangePage}
          changeItemsPerPage={handleChangeItemsPerPage}
          minRows={10}
        />
      </Box>
    </>
  );
}

export default AlertManagement;
